import { ActionType, createAction } from "typesafe-actions";

import ApiService from "./ApiService";

export const setApi = createAction("@api/set")<ApiService>();
export const setReadonlyApi = createAction("@readonlyApi/set")<ApiService>();
export type Actions = ActionType<typeof setApi | typeof setReadonlyApi>;
